<template>
    <div>
        <v-toolbar
            dense
            tabs
            color="primary darken-2"
            dark
            class="page_title"
        >
            <v-toolbar-title class="pa-0 pr-0 mt-1">
                <v-layout row >
                    <v-flex xs10 sm11 text-xs-left>
                        <a href="javascript: history.go(-1)" class="pa-0">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-arrow-left headline"></i>
                            </v-btn>
                        </a>
                        Become a Partner
                    </v-flex>
                    <v-flex xs2 sm1 text-xs-right>
                        <router-link :to="{name: 'All'}" class="pa-0 text-xs-right">
                            <v-btn flat fab small class="pa-0">
                                <i class="fas fa-close headline"></i>
                            </v-btn>
                        </router-link>
                    </v-flex>
                </v-layout>
            </v-toolbar-title>
        </v-toolbar>

        <v-container>
            <v-layout row>
                <v-flex xs12 md10 offset-md1>
                    <v-slide-y-transition mode="out-in">
                        <div>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md6 class="pa-2" v-if="!is_marketer" @click.stop="marketer = true" @click="Dialog = true" >
                                    <v-hover>
                                        <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 4}`" style="border-radius: 5px; font-size: small; cursor: pointer">
                                            <v-layout row >
                                                <v-flex xs8 class="text-xs-left">
                                                    <h5 class="subheading mt-1 pl-3 pt-2 pb-0 mb-0"><b>Become Our Brand Ambassador</b></h5>
                                                </v-flex>
                                                <v-flex xs4  class="text-xs-left">
                                                    <v-btn fab color="teal" class="mt-2 ml-3 mb-0 mr-2 white--text">
                                                        <i class="fas fa-coins fa-2x"></i>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-card-title primary-title class="pb-0 mt-0 pt-1" style="color: #424242">
                                                <div>
                                                    <div class="caption mt-0 mb-0 pb-2">Receive enticing <b>commissions </b> for every active new client brought onboard.</div>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                                <v-flex xs12 sm6 md6 class="pa-2" v-else>
                                    <v-hover>
                                        <v-card to="/dashboard/affiliateMarketing" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 4}`" style="border-radius: 5px; font-size: small; cursor: pointer">
                                            <v-layout row >
                                                <v-flex xs8 class="text-xs-left">
                                                    <h5 class="subheading mt-1 pl-3 pt-2 pb-0 mb-0"><b>View My Affiliate Clients</b></h5>
                                                </v-flex>
                                                <v-flex xs4  class="text-xs-left">
                                                    <v-btn fab color="teal" class="mt-2 ml-3 mb-0 mr-2 white--text">
                                                        <i class="fas fa-coins fa-2x"></i>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-card-title primary-title class="pb-0 mt-0 pt-1" style="color: #424242">
                                                <div>
                                                    <div class="caption mt-0 mb-0 pb-2">View how much <b>commissions </b> you have received for every active new client brought onboard.</div>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                                <v-flex xs12 sm6 md6 class="pa-2" @click="businessDialog = true">
                                    <v-hover>
                                        <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 4}`" style="border-radius: 5px; font-size: small; cursor: pointer">
                                            <v-layout row >
                                                <v-flex xs8 class="text-xs-left">
                                                    <h5 class="subheading mt-1 pl-3 pt-2 pb-0 mb-0"><b>Unlock Business Suite</b></h5>
                                                </v-flex>
                                                <v-flex xs4  class="text-xs-left">
                                                    <v-btn fab color="primary" class="mt-2 ml-3 mb-0 mr-2 white--text">
                                                        <i class="fas fa-briefcase fa-2x"></i>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-card-title primary-title class="pb-0 mt-0 pt-1" style="color: #424242">
                                                <div>
                                                    <div class="caption mt-0 mb-0 pb-2">Unlock access to <b>premium tools</b> and services tailored for growing teams, creators, and professionals.</div>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </v-layout>
                            <v-dialog width="500px" v-model="Dialog"> 
                                <v-card> 
                                    <v-card-title class="headline primary darken-2 white--text" primary-title>Confirm Partnership</v-card-title> 
                                    <v-card-text v-if="investor" class="pa-4">
                                        <h2>Partnership Strong Points</h2>
                                        <ul v-for="(point, index) in investment_points" :key="index">
                                            <li> {{  point }}</li>
                                        </ul>
                                        <ul v-for="(point, index) in marketing_points" :key="index">
                                            <li> {{  point }}</li>
                                        </ul>
                                        Click submit below to validated your partnership interest.
                                    </v-card-text>
                                    <v-card-text v-if="marketer" class="pa-4">
                                        <h2>Partnership Strong Points</h2>
                                        <ul v-for="(point, index) in investment_points" :key="index">
                                            <li> {{  point }}</li>
                                        </ul>
                                        <ul v-for="(point, index) in marketing_points" :key="index">
                                            <li> {{  point }}</li>
                                        </ul>
                                        Click submit below to validated your partnership interest.
                                    </v-card-text>

                                    <v-card-actions> 
                                        <v-btn color="teal" class="white--text" @click="becomePartner()" > Submit </v-btn> 
                                        <v-spacer></v-spacer> 
                                        <v-btn color="teal" flat @click="Dialog = false" > Cancel </v-btn> 
                                    </v-card-actions> 
                                </v-card> 
                            </v-dialog> 
                            <v-dialog v-model="businessDialog" max-width="500" persistent>
                                <v-card class="elevation-12">
                                    <v-card-title class="headline primary white--text pa-4">
                                        <v-icon left dark>mdi-account-group</v-icon>
                                        Business Suite Activation
                                    </v-card-title>
                                    <v-card-text class="pa-4">
                                        <div class="text-center mb-4">
                                            <v-icon x-large color="primary" class="mb-2">mdi-rocket-launch</v-icon>
                                            <h3 class="subtitle-1 font-weight-medium mb-2">
                                                Accelerate Your Business Growth 🚀
                                            </h3>
                                            <p class="body-2 grey--text text--darken-1">
                                                Unlock access to premium tools and services tailored for growing teams, creators, and professionals.
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <b><i class="fa-solid fa-sack-dollar"></i> PettyCash Business Tools: </b>
                                                <br>Manage funds, services, and user registration from one place.
                                            </p>
                                            <p>
                                                <b><i class="fa-solid fa-chalkboard-user"></i> Affiliate Marketing Course: </b>
                                                <br>Learn how to generate revenue through smart marketing.
                                            </p>
                                            <p>
                                                <b><i class="fa-solid fa-table-columns"></i> Business Dashboard: </b>
                                                <br>Track performance and manage operations in real time.
                                            </p>
                                            <p>
                                                <b><i class="fa-solid fa-star-of-life"></i> Support & Legal Assistance: </b>
                                                <br>Get help and stay compliant with our legal center.
                                            </p>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions class="pa-4 pt-0">
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="businessDialog = false" class="grey--text text--darken-1">
                                            Not Now
                                        </v-btn>
                                        <v-btn color="primary" depressed @click="startBusinessSetup">
                                            Activate Now
                                            <v-icon right>mdi-arrow-right</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </div>
                    </v-slide-y-transition>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import 'animate.css'

    export default {
        data() {
            return {
                Dialog: false,
                investor: false,
                marketer: false,
                marketing_points: [
                    "1. Strong understanding of marketing principles and strategies.",
                    "2. Proven track record of success in sales and marketing.",
                    "3. Excellent communication and persuasion skills.",
                    "4. Ability to build and maintain client relationships.",
                    "5. Knowledge of various marketing channels and platforms.",
                    "6. Proficiency in using digital marketing tools and analytics.",
                    "7. Results-driven mindset and ability to meet sales targets.",
                ],
                investment_points: [
                    "1. Demonstrated expertise in the relevant industry or field.",
                    "2. Proven track record of entrepreneurial success and business growth.",
                    "3. Strong leadership and decision-making skills.",
                    "4. Financial acumen and ability to analyze and interpret data.",
                    "5. Effective problem-solving and critical thinking abilities.",
                    "6. Exceptional networking and relationship-building skills.",
                    "7. Passion, drive, and commitment to the vision and goals of the business.",
                ],
                is_marketer: false,
                businessDialog: false,
            }
        },
        
        mounted(){
            // executes these after the page has been mounted
            document.title = "PettyCash | Become a Partner."
            this.$store.commit('setCloseURL', "/")
            this.checkMarketer()
        },

        methods:{
            startBusinessSetup() {
                this.businessDialog = false;
                this.$router.push({ name: 'create_business_account4' });
            },
            async checkMarketer() {
                try {
                    const response = await axios.get('/api/v1/home/check_marketer/');
                    this.is_marketer = response.data.is_marketer;
                } catch (error) {
                    console.log("Erreur dans checkMarketer:", error);
                }
            },

            async becomePartner(){
                this.$store.commit('setIsLoading', true)
                this.Dialog = false
    
                axios
                    .post('/api/v1/home/become/partner/', {'investor': this.investor, 'marketer': this.marketer})
                    .then(response => {
                        this.investor = false
                        this.marketer = false
                        const data = (response.data && response.data[0]) ? response.data[0] : {}
                        this.$store.dispatch('showSnackBar', {
                            message: data.text || "Your partnership request has been submitted.",
                            color: data.color || "teal darken-4"
                        })
                    })
                    .catch(error => {
                        if (error.response){
                            this.$store.dispatch('showSnackBar', {
                                message: error.response.status + " " + error.response.statusText,
                                color: "red darken-4"
                            })
                        }else{
                            this.$store.dispatch('showSnackBar', {
                                message: "An error occured, please check your internet connection and try again later.",
                                color: "red darken-4"
                            })
                        }
                    })

                this.$store.commit('setIsLoading', false)

            },
        },
    }
</script>
